<div class="flex min-h-dvh flex-col">
  <router-outlet />
</div>
